import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlocksRoutingModule } from './blocks-routing.module';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './menu/menu.component';
import { AppComponent } from './root/app.component';
import { SharedModule } from '../shared/shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthorizedContainerComponent } from './authorized-container/authorized-container.component';
import { AnynoumouseContainerComponent } from './anynoumouse-container/anynoumouse-container.component';
import { NavComponent } from './nav/nav.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [
    HomeComponent,
    MenuComponent,
    AppComponent,
    AuthorizedContainerComponent,
    AnynoumouseContainerComponent,
    NavComponent,
  ],
  imports: [
    SharedModule,
    BlocksRoutingModule,
    OverlayPanelModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
  ],
  exports:[AppComponent,MenuComponent,NavComponent]
})
export class BlocksModule { }
